/**
 * 标完成要有证据（0930 Tony：「工作台不能直接点击完成，不然很多具体的任务都没处理，偷懒直接完成了」）。
 *
 * 真正的判据在后端 apps/api/src/projects/plan-node-completion-gate.ts，这里只为了**提前说**：
 * 点保存之前就告诉人还差什么，不用等接口退回来。门槛和文案两边保持一致
 * （plan-completion.spec.ts 读后端源码钉着门槛）。
 *
 * · 挂了交付物的：每份没取消的交付物都传了文件才能标完成；
 * · 没挂交付物的：写一句完成说明（做了什么、结果放在哪），记进改动记录；
 * · 阶段不走这条：阶段的完成度按下面的活动汇总。
 */
export const COMPLETION_NOTE_MIN_CHARS = 5;

/** 一个节点挂的交付物里：没取消的份数、没传文件的标题 */
export interface CompletionFacts {
  live: number;
  missing: readonly string[];
}

export type CompletionGate =
  | { kind: 'files'; missing: readonly string[] }
  | { kind: 'note' }
  | { kind: 'ok'; live: number };

/** 这个节点要标完成，还差什么；阶段返回 null（不管） */
export function completionGate(
  nodeType: string | null | undefined,
  facts: CompletionFacts | null | undefined,
): CompletionGate | null {
  if (nodeType === 'phase') return null;
  const live = facts?.live ?? 0;
  if (live > 0) {
    const missing = facts?.missing ?? [];
    return missing.length ? { kind: 'files', missing } : { kind: 'ok', live };
  }
  return { kind: 'note' };
}

export function completionNoteEnough(note: string | null | undefined): boolean {
  return (note ?? '').trim().length >= COMPLETION_NOTE_MIN_CHARS;
}

/** 和后端 completionBlockReason 同一句话 */
export function missingFilesText(missing: readonly string[]): string {
  const listed = missing.slice(0, 3).map((title) => `「${title}」`).join('');
  return `还有 ${missing.length} 份交付物没传文件：${listed}${missing.length > 3 ? ' 等' : ''}。`
    + '传完才能标完成；不需要的交付物请项目经理在交付物页取消。';
}

export const NOTE_REQUIRED_TEXT =
  `这条任务没挂交付物，标完成要写一句完成说明：做了什么、结果放在哪（至少 ${COMPLETION_NOTE_MIN_CHARS} 个字）。`;
